import { RestRequest, } from '@Utils';
import { IPreviewContact, ISharedContact, } from 'atlas-shared/dist';

export * from './abstract/gdpr.api.abstract';

export const anonymizeContact = (organization_id: ISharedContact['id'], contact_id: ISharedContact['id']) => {
  return RestRequest.put<any, IPreviewContact>(`gdpr/${organization_id}/anonymize/contact/${contact_id}`, {});
};
